import AnsweredQuestion from './AnsweredQuestion';

export default AnsweredQuestion;
